import { render } from "./TopBar.vue?vue&type=template&id=46028e30&scoped=true"
const script = {}

import "./TopBar.vue?vue&type=style&index=0&id=46028e30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46028e30"]])

export default __exports__